import { useMutation } from "@tanstack/react-query";
import { positionDelete } from "common/api/unos_rad/unos_position";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseUnosPositionDeleteParams = {
  invalidateKeys?: string[];
};

export const useUnosPositionDelete = (
  hookParams?: UseUnosPositionDeleteParams
) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: positionDeleteMutate } = useMutation({
    mutationFn: async (id: string) => await positionDelete(id),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }
    },
  });

  return { positionDeleteMutate };
};
